import "@splidejs/splide/css";
import initPickup from "./initPickup";

export default function initSplide() {
  initPickup();
}
